import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .buttons {
    margin-top: 10px;
    display: flex;
    gap: 10px;

    button {
      width: 100%;
      font-family: inherit;
      padding: 5px;
      cursor: pointer;
      border-radius: 4px;
      font-weight: bold;
      font-size: 14px;
      box-sizing: border-box;

      &.primary {
        background-color: #67ae8b;
        color: #fff;
        border: none;
        outline: none;
      }

      &.secondary {
        border: 2px solid #67ae8b;
        background-color: #fff;
        color: #67ae8b;
      }
    }
  }
`;
